import { Route, Routes } from "react-router-dom";

import G4DynamicData from "./G4DynamicData/main";
import G4Positions from "./G4Positions/main";
import G4MetaData from "./G4MetaData/main";
import G4SustainAnalytics from "./G4SustainAnalytics/main";
import G4DownloadCenter from "./G4DownloadCenter/main";

import { Tables } from "../../gen/tableNames/tables";

export default function G4Routes() {
  return (
    <Routes>
      <Route path={`${Tables.G4_DYNAMIC_DATA}/*`} element={<G4DynamicData />} />
      <Route path={`${Tables.G4_POSITIONS}/*`} element={<G4Positions />} />
      <Route path={`${Tables.G4_METADATA}/*`} element={<G4MetaData />} />
      <Route
        path={`${Tables.G4_SUSTAINALYTICS_ESG}/*`}
        element={<G4SustainAnalytics />}
      />
      <Route path="g4_download_center/*" element={<G4DownloadCenter />} />
    </Routes>
  );
}
